import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataVariablesInterface } from '../data/variables.interface';
import { GtmStatsAdapterLanguage } from './language';
import { GtmStatsAdapterList } from './list';
import { GtmStatsAdapterCategory } from './category';

export class GtmStatsAdapterVariables implements StatsAdapterInterface {
  /**
   * Constructor
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataVariablesInterface {
    return {
      country: this.getCountry(),
      language: this.getLanguage(),
      pageCategory: this.getPageCategory(),
      pageType: this.getPageType(),
      userId: this.getUserId(),
      userStatus: this.getUserStatus(),
    };
  }

  /**
   * Returns the country
   */
  public getCountry(): string {
    return this.context.global.country || '';
  }

  /**
   * Returns the page category
   */
  public getPageCategory(): string {
    if (this.context.global.error_page) {
      return '404 Pages';
    }

    return new GtmStatsAdapterCategory(this.context.global.property_category_identifier).getData();
  }

  /**
   * Returns the language
   */
  public getLanguage(): string {
    return new GtmStatsAdapterLanguage(this.context).getData();
  }

  /**
   * Returns the page type
   */
  public getPageType(): string {
    return new GtmStatsAdapterList(this.context).getData();
  }

  /**
   * Returns the user ID
   */
  public getUserId(): string {
    return (this.context.global.authentication.user && String(this.context.global.authentication.user.id)) || '';
  }

  /**
   * Returns the user status
   */
  public getUserStatus(): string {
    return this.context.global.authentication.user ? 'Logged In' : 'Not Logged In';
  }
}
